// ** React Imports
import { useState, createContext } from 'react'

// ** Intl Provider Import
import { IntlProvider } from 'react-intl'

// ** Core Language Data
import messagesEn from '@assets/data/locales/en.json'
import messagesDe from '@assets/data/locales/de.json'
import messagesFr from '@assets/data/locales/fr.json'
import messagesPt from '@assets/data/locales/pt.json'

// ** User Language Data
import userMessagesEn from '@src/assets/data/locales/en.json'
import userMessagesDe from '@src/assets/data/locales/de.json'
import userMessagesFr from '@src/assets/data/locales/fr.json'
import userMessagesPt from '@src/assets/data/locales/pt.json'
import userMessagesEs from '@src/assets/data/locales/es.json'

// ** Flatpickr Object
import flatpickr from "flatpickr"

// ** Flatpickr languajes
import { Spanish } from 'flatpickr/dist/l10n/es'
import { english } from 'flatpickr/dist/l10n/default'

// ** Custom Hooks
import { useMetricsLang } from '@hooks/useMetricsLang'

// ** Menu msg obj
const menuMessages = {
  en: { ...messagesEn, ...userMessagesEn },
  es: { ...userMessagesEs },
  de: { ...messagesDe, ...userMessagesDe },
  fr: { ...messagesFr, ...userMessagesFr },
  pt: { ...messagesPt, ...userMessagesPt }
}

const flatLangConfig = {
  en: english,
  es: Spanish
}

// ** Create Context
const Context = createContext()

const IntlProviderWrapper = ({ children }) => {
  const metricsMessages = useMetricsLang()
  // console.log(metricsMessages)

  // ** States
  const [locale, setLocale] = useState('es')
  const [messages, setMessages] = useState(menuMessages['es'])

  // ** Switches Language
  const switchLanguage = lang => {
    setLocale(lang)
    setMessages(menuMessages[lang])
    flatpickr.localize(flatLangConfig[lang])
  }

  return (
    <Context.Provider value={{ locale, switchLanguage }}>
      <IntlProvider key={locale} locale={locale} messages={messages} defaultLocale='es'>
        {children}
      </IntlProvider>
    </Context.Provider>
  )
}

export { IntlProviderWrapper, Context as IntlContext }
